import { useEffect } from "react";
import { Route } from "react-router-dom";

export const RedirectToLogistics = ({ path }: { path: string }) => {
  useEffect(() => {
    window.location.replace(`/GoHaul${path}`);
  }, [path]);
  return null;
};

const RedirectToLogisticsCatchAll = () => {
  useEffect(() => {
    window.location.replace(window.location.pathname + window.location.search);
  }, []);
  return null;
};

export const LogisticsRoutes = () => (
  <>
    <Route path="/logistics" element={<RedirectToLogistics path="" />} />
    <Route path="/logistics/login" element={<RedirectToLogistics path="/login" />} />
    <Route path="/logistics/register" element={<RedirectToLogistics path="/signup" />} />
    <Route path="/logistics/become-rider" element={<RedirectToLogistics path="/drive" />} />
    <Route path="/logistics/request" element={<RedirectToLogistics path="/ship" />} />
    <Route path="/logistics/track" element={<RedirectToLogistics path="/activity" />} />
    <Route path="/dashboard/logistics/customer" element={<RedirectToLogistics path="/account" />} />
    <Route path="/dashboard/logistics/driver" element={<RedirectToLogistics path="/activity" />} />
    <Route path="/dashboard/logistics/fleet-owner" element={<RedirectToLogistics path="/account" />} />
    <Route path="/admin/drivers" element={<RedirectToLogistics path="/admin/drivers" />} />
    <Route path="/admin/logistics/drivers" element={<RedirectToLogistics path="/admin/drivers" />} />
    <Route path="/admin/logistics" element={<RedirectToLogistics path="/admin" />} />
    <Route path="/GoHaul/*" element={<RedirectToLogisticsCatchAll />} />
  </>
);
